import { render, staticRenderFns } from "./Management-patents.vue?vue&type=template&id=6ca2492a&scoped=true&"
import script from "./Management-patents.vue?vue&type=script&lang=js&"
export * from "./Management-patents.vue?vue&type=script&lang=js&"
import style0 from "./Management-patents.vue?vue&type=style&index=0&id=6ca2492a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca2492a",
  null
  
)

export default component.exports